/* eslint-disable jsx-a11y/no-autofocus */
import { URLS } from "@core/shared/utils";
import { SubmitButton } from "@design-system/components/Button";
import { PasswordInput, TextInput } from "@design-system/components/Form";
import { BaseLink, ReturnToHome } from "@design-system/components/link";
import { useLogin } from "@framework/auth/hooks";
import { trans, plainTrans } from "@mongez/localization";
import { Form } from "@mongez/react-form";
import { LoginBrowserHelp } from "./LoginBrowserHelp";

export function LoginForm() {
  const login = useLogin();

  return (
    <div className="w-full space-y-8">
      <ReturnToHome />
      <div className="space-y-1.5">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
          {trans("auth.welcomeBack")}
        </h2>
        <p className="text-sm text-muted-foreground dark:text-gray-300">
          {trans("auth.enterCredentials")}
        </p>
      </div>

      <Form onSubmit={login} className="space-y-6">
        <LoginBrowserHelp />
        <div className="space-y-4">
          <TextInput
            autoFocus
            name="email"
            label={trans("auth.emailOrPhoneNumber")}
            placeholder={plainTrans("auth.emailOrPhoneNumber")}
            required
          />
          <PasswordInput
            name="password"
            label={trans("auth.password")}
            placeholder={plainTrans("auth.password")}
            required
          />
        </div>
        <div className="space-y-4">
          <SubmitButton className="h-11 w-full bg-primary text-primary-foreground shadow-lg transition-all duration-300 hover:scale-105 hover:bg-primary/90 hover:shadow-xl dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700">
            {trans("auth.signIn")}
          </SubmitButton>

          <div className="flex items-center justify-between text-sm">
            <BaseLink
              to={URLS.auth.forgotPassword}
              type="button"
              className="h-auto p-0 text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100"
            >
              {trans("auth.forgotPassword")}
            </BaseLink>
            <BaseLink
              to={URLS.auth.register}
              type="button"
              className="h-auto p-0 text-gray-600 duration-300 hover:text-gray-900 hover:underline dark:text-gray-400 dark:hover:text-gray-100"
            >
              {trans("auth.createAccount")}
            </BaseLink>
          </div>
        </div>
      </Form>
    </div>
  );
}
